import React from 'react';
import { useTranslation } from 'react-i18next';
import './Skills.css';

function SkillsList({ skills, selectedSkill, onSelectSkill, loading }) {
  const { t } = useTranslation('admin');
  if (loading) {
    return (
      <div className="skills-list">
        <div style={{ padding: '16px', textAlign: 'center', color: 'var(--text-secondary)' }}>
          {t('skills.loading')}
        </div>
      </div>
    );
  }

  if (!skills || skills.length === 0) {
    return (
      <div className="skills-list">
        <div style={{ padding: '16px', textAlign: 'center', color: 'var(--text-secondary)' }}>
          {t('skills.noData.empty')}
        </div>
      </div>
    );
  }

  return (
    <div className="skills-list">
      {skills.map(skill => (
        <div
          key={skill.skill_id}
          className={`skill-item ${selectedSkill?.skill_id === skill.skill_id ? 'selected' : ''}`}
          onClick={() => onSelectSkill(skill)}
        >
          <div className="skill-item-header">
            <div className="skill-item-name">{skill.skill_name}</div>
            <div className={`skill-category-badge skill-category-${skill.skill_category}`}>
              {skill.skill_category}
            </div>
          </div>
          <div className="skill-item-code">{skill.skill_code}</div>
        </div>
      ))}
    </div>
  );
}

export default SkillsList;
